import { Controller } from "@hotwired/stimulus"

export default class CoreuiSidebarControlController extends Controller {
  static outlets = ["coreui-sidebar"]

  toggle(event) {
    this.coreuiSidebarOutlets.forEach((owner) => owner.toggle(event))
  }

  show(event) {
    this.coreuiSidebarOutlets.forEach((owner) => owner.show(event))
  }

  hide() {
    this.coreuiSidebarOutlets.forEach((owner) => owner.hide())
  }
}
